export default __webpack_public_path__ + "static/media/arrow_fall.89220dc3.svg";